













import { Component, Prop, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import ToolBadge from '@/components/Utilities/ToolBadge.vue';
import openbitlab from '@/types.d';
import { filter, values } from 'lodash';
import ServiceBadge from '../Utilities/ServiceBadge.vue';

@Component({
  components: {
    ToolBadge,
    ServiceBadge,
  },
})
export default class ToolsAndServices extends Vue {
  @Prop({ required: true }) readonly project!: openbitlab.Project;

  @State('services') services!: openbitlab.RootState['services']

  @State('tools') tools!: openbitlab.RootState['tools']

  getServices(): Array<openbitlab.Service> {
    return filter(values(this.services), (s) => s.chain === this.project.name);
  }

  getTools(): Array<openbitlab.Tool> {
    return values(this.tools);
  }
}
